import * as yup from 'yup'

export const ratingSchema = yup.object({
    rate: yup
        .number()
        .min(1, 'La calificación mínima es 1 estrella')
        .max(5, 'La calificación máxima es 5 estrellas')
        .required('La calificación es obligatoria'),
    comment: yup
        .string()
        .min(10, 'El comentario debe tener al menos 10 caracteres')
        .max(500, 'El comentario no puede exceder 500 caracteres')
        .required('El comentario es obligatorio')
})

export interface RatingFormData {
    rate: number
    comment: string
}